import { useContext, useEffect, useState } from "react";
import { LangContext } from "../../context/LangContext";
import useFormatImage from "../../hooks/useFormatImage";
import Textarea from "../../components/Textarea";
import Slider from "../../components/Slider";
import Onglet from "../../components/Onglet";
import "./style.css"

function Home() {
    const [dataPage, setDataPage] = useState(null);
    const { language, translations } = useContext(LangContext);

    useEffect(() => {
        localStorage.setItem('opt_return_work', '');

        let ignore = false;

        const fetchDataPage = async () => {
            try {
                const req = await fetch(`${process.env.REACT_APP_API_URL}/vanrah/profile`);
                const res = await req.json();

                if (!ignore && req.status === 200) {
                    setDataPage({
                        logo: res.logo || null,
                        descrip_fr: res.descrip_fr || '',
                        descrip_en: res.descrip_en || '',
                        images: res.images || [],
                        series: res.series || [],
                        video: res.video || [],
                    });
                }
            } catch (e) { }
        };

        fetchDataPage();

        return () => { ignore = true; };

    }, []);

    const logoURL = useFormatImage({ image: dataPage?.logo });

    const seriePath = (serie) => {
        const path = serie.type === 1 ? 'mangas' : 'works';
        return `/${path}/${serie.title_path}`;
    };

    if (!dataPage) return null;

    return (
        <div className='page page_home'>
            <section className="sect_presentation">
                <div className="author_descrip">
                    <h2 className="subtitle_page">-<span>VanRah</span>-</h2>

                    <i
                        className="logo_avatar"
                        style={{ backgroundImage: `url('${logoURL}')` }}
                    />

                    <Textarea
                        label={translations.author_presentation}
                        text={dataPage[`descrip_${language}`]}
                    />
                </div>

                <Slider images={dataPage.images} />
            </section>

            <section className="sect_published_series">
                <h2 className="subtitle_page">
                    -<span>{translations.published_series}</span>-
                </h2>

                {dataPage.series.length !== 0 &&
                    <ul>
                        {dataPage.series.map(serie =>
                            <Onglet
                                key={serie.title_path}
                                serie={serie}
                                to={seriePath(serie)}
                            />
                        )}
                    </ul>
                }
            </section>

            {dataPage.video.length !== 0 &&
                <section className="sect_videos">
                    <h2 className="subtitle_page">
                        -<span>{translations.discover_artist}</span>-
                    </h2>

                    <ul>
                        {dataPage.video.map((url, idx) =>
                            <li key={idx} className="video">
                                <iframe
                                    title="video"
                                    loading="lazy"
                                    src={url.replace("youtube.com", "youtube-nocookie.com")}
                                    width="100%"
                                    height="100%"
                                    frameBorder="0"
                                    allowFullScreen
                                />
                            </li>
                        )}
                    </ul>
                </section>
            }
        </div>
    );
}

export default Home;